// The split-pane menu: beside the content on a desktop, a drawer on a phone.
import { IonContent, IonIcon, IonItem, IonLabel, IonList, IonMenu, IonMenuToggle } from "@ionic/react";
import { calendarOutline, tvOutline, phonePortraitOutline, fileTrayStackedOutline, gitNetworkOutline, statsChartOutline,
  ribbonOutline, chatbubblesOutline, settingsOutline, logOutOutline } from "ionicons/icons";
import { useLocation } from "react-router-dom";
import { can, useMe } from "../api/live";
import { fixtureMode } from "../api/mode";
import { logout } from "../auth/auth";

const ITEMS = [
  { to: "/week", label: "Week", icon: calendarOutline },
  { to: "/bench", label: "Bench", icon: phonePortraitOutline },
  { to: "/board", label: "Board", icon: tvOutline },
  { to: "/shelves", label: "Shelves", icon: fileTrayStackedOutline },
  { to: "/tasks", label: "Build flow", icon: gitNetworkOutline },
  { to: "/stats", label: "Stats", icon: statsChartOutline },
  { to: "/skills", label: "Skills", icon: ribbonOutline },
  { to: "/review", label: "Review", icon: chatbubblesOutline },
  { to: "/settings", label: "Settings", icon: settingsOutline, role: "admin" as const }
];

export function Menu() {
  const { pathname } = useLocation();
  const { me, reload } = useMe();
  const signOut = async () => {
    if (!fixtureMode()) { try { await logout(); } catch { /* the token is dropped locally anyway */ } }
    reload();
  };
  return (
    <IonMenu contentId="main" type="overlay">
      <IonContent>
        <div className="menu__brand"><b>OnlyCat</b><span>Production planner</span></div>
        <IonList lines="none">
          {ITEMS.filter((i) => !i.role || can(me, i.role)).map((i) => (
            <IonMenuToggle key={i.to} autoHide={false}>
              <IonItem routerLink={i.to} routerDirection="root" detail={false} className={pathname.startsWith(i.to) ? "is-active" : ""}>
                <IonIcon slot="start" icon={i.icon} aria-hidden="true" />
                <IonLabel>{i.label}</IonLabel>
              </IonItem>
            </IonMenuToggle>
          ))}
        </IonList>
        {me ? (
          <div className="menu__who">
            <b>{me.person?.name ?? me.email ?? "Signed in"}</b> · {me.role}{fixtureMode() ? " · fixture data" : ""}
          </div>
        ) : null}
        <IonList lines="none">
          <IonItem button detail={false} onClick={signOut}>
            <IonIcon slot="start" icon={logOutOutline} aria-hidden="true" />
            <IonLabel>Sign out</IonLabel>
          </IonItem>
        </IonList>
      </IonContent>
    </IonMenu>
  );
}
